import { render, staticRenderFns } from "./BudgetTreeNode.vue?vue&type=template&id=71e1cdaf&"
import script from "./BudgetTreeNode.vue?vue&type=script&lang=ts&"
export * from "./BudgetTreeNode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports